<template>
  <div class="form-group form-group--read-only">
    <div class="row">
      <div :class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}</label>
        <div class="lead">
          <div
            v-for="(item, index) in value"
            :key="index"
            class="row"
            style="padding: 0 15px;"
          >
            <div
              class="file-read-only-download-card"
            >
              <div class="row">
                <div class="col-6">
                  <span class="name" style="font-weight: 600;">{{ item.name }}</span>
                </div>
                <div class="col-6 text-right">
                  <span class="size">{{ bytesToSize(item.size) }}</span>
                  <button
                    class="btn btn-link"
                    @click="onOpen(item.url, item.name)"
                  >
                    DOWNLOAD <span class="glyphicon glyphicon-save"/>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['component', 'components', 'value'],
  name: 'file-read-only',
  methods: {
    onOpen (url, nome) {
      window.open(url, '_blank')
      /* this.forceDownloadBase64({
        nome,
        url
      }) */
    },
    async forceDownloadBase64 ({ nome, url }) {
      const a = window.document.createElement('a')
      a.download = nome

      const response = await axios({
        method: 'GET',
        url,
        responseType: 'arraybuffer'
      })

      let binary = ''
      const bytes = new Uint8Array(response.data)
      const len = bytes.byteLength
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[ i ])
      }

      const base64 = btoa(binary)

      a.href = `data:application;base64,${base64}`
      a.click()
    },
    bytesToSize (size) {
      var filesizeBase = 1000
      var dictFileSizeUnits = { tb: 'TB', gb: 'GB', mb: 'MB', kb: 'KB', b: 'b' }

      var selectedSize = 0
      var selectedUnit = 'b'

      if (size > 0) {
        var units = ['tb', 'gb', 'mb', 'kb', 'b']

        for (var i = 0; i < units.length; i++) {
          var unit = units[i]
          var cutoff = Math.pow(filesizeBase, 4 - i) / 10

          if (size >= cutoff) {
            selectedSize = size / Math.pow(filesizeBase, 4 - i)
            selectedUnit = unit
            break
          }
        }

        selectedSize = Math.round(10 * selectedSize) / 10 // Cutting of digits
      }

      return selectedSize + ' ' + dictFileSizeUnits[selectedUnit]
    }
  }
}
</script>
